<template>
    <section :class="[{ 'bg-white': !content.backgroundColor && !content.backgroundMedia }, sectionClasses]" :style="backgroundStyles">
        <div
            class="structure-section px-4"
            :class="{ [content.cssClass]: content.cssClass, 'container m-auto ': content.sizingMode === 'boxed', 'w-full': content.sizingMode === 'fullwidth' }"
        >
            <div class="grid grid-cols-12 gap-4">
                <div
                    v-if="content.type === 'sidebar'"
                    :class="{ 'col-span-12': content.mobileSidebarBehavior === 'wrap','hidden': content.mobileSidebarBehavior === 'hidden' }"
                    class="md:flex md:flex-col md:gap-4 md:col-span-3"
                >
                    <StructureBlock
                        v-for="(sidebarBlock) in sidebarBlocks"
                        :key="sidebarBlock.id"
                        :content="sidebarBlock"
                        :ssr="content?.customFields?.ssr_rendering"
                        :count="count"
                        :section-sizing-mode="content.sizingMode"
                    />
                </div>
                <div :class="{ 'md:col-span-9': content.type === 'sidebar' }" class="flex flex-col col-span-12">
                    <StructureBlock
                        v-for="(mainBlock) in mainBlocks"
                        :key="mainBlock.id"
                        :content="mainBlock"
                        :ssr="content?.customFields?.ssr_rendering"
                        :count="count"
                        :section-sizing-mode="content.sizingMode"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { computed, type Ref } from 'vue'
import type { HblBlock, HblSection } from '@/utils/types'
import { hblGetStructureBackgroundStyles } from '@/utils/helper'

const props = defineProps<{
    count?: number
    content: HblSection
}>()

const { backgroundStyles } = hblGetStructureBackgroundStyles(props.content)

const sectionClasses = computed(() => {
    // Visibility classes for mobile/tablet/desktop
    const visibilityClasses = []

    if (props.content.visibility) {
        // Mobile visibility
        if (props.content.visibility.mobile) {
            visibilityClasses.push('block')
        } else {
            visibilityClasses.push('hidden')
        }

        // Tablet visibility
        if (props.content.visibility.tablet) {
            visibilityClasses.push('md:block')
        } else {
            visibilityClasses.push('md:hidden')
        }

        // Desktop visibility
        if (props.content.visibility.desktop) {
            visibilityClasses.push('xl:block')
        } else {
            visibilityClasses.push('xl:hidden')
        }
    }

    return visibilityClasses.join(' ')
})

const mainBlocks: Ref<HblBlock[]> = computed(() => {
    return props.content.blocks.filter((block: HblBlock) => block.sectionPosition === 'main')
})

const sidebarBlocks: Ref<HblBlock[]> = computed(() => {
    return props.content.blocks.filter((block: HblBlock) => block.sectionPosition === 'sidebar')
})
</script>
